import { Stack, Typography } from "@mui/material"
import { Plus } from "@untitled-ui/icons-react"

import { TokenInfo } from "../../ao/token"
import { NumberFont, TitleFont } from "../../theme"
import { formatNumberAuto, formatTicker } from "../../utils/format"
import { BeeLetter } from "../BeeLetter"
import TokenLogo from "../TokenLogo"
import { TokenPill } from "../TokenPill"

type AddOrderPendingFormProps = {
  tokenA: TokenInfo
  tokenB: TokenInfo
  tokenAValue: string
  tokenBValue: string
}

export function AddOrderPendingForm(props: AddOrderPendingFormProps) {
  const { tokenAValue, tokenBValue, tokenA, tokenB } = props

  return (
    <Stack gap={1} alignItems="center">
      <BeeLetter />
      <Typography variant="h5" fontFamily={TitleFont}>
        Pending Transaction
      </Typography>
      <Stack
        direction="row"
        gap={1}
        alignItems="center"
        sx={{
          width: "100%",
          "& > *": {
            flex: 1,
            flexShrink: 0,
            overflow: "hidden",
          },
          "& > *:nth-child(1)": {
            flexBasis: "calc(50% - 12px - var(--spacing))",
            alignItems: "flex-end",
          },
          "& > *:nth-child(2)": {
            flexBasis: "24px",
          },
          "& > *:nth-child(3)": {
            flexBasis: "calc(50% - 12px - var(--spacing))",
          },
        }}
      >
        <Stack>
          <TokenPill variant="outlined">
            <TokenLogo tx={tokenA.logo} alt={`${tokenA.name} logo`} size="small" />
            <Typography
              fontFamily={NumberFont}
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {formatNumberAuto(tokenAValue)}
            </Typography>
            {formatTicker(tokenA.ticker)}
          </TokenPill>
        </Stack>
        <Plus />
        <Stack>
          <TokenPill variant="outlined">
            <TokenLogo tx={tokenB.logo} alt={`${tokenB.name} logo`} size="small" />
            <Typography
              fontFamily={NumberFont}
              sx={{
                textOverflow: "ellipsis",
                overflow: "hidden",
              }}
            >
              {formatNumberAuto(tokenBValue)}
            </Typography>
            {formatTicker(tokenB.ticker)}
          </TokenPill>
        </Stack>
      </Stack>
    </Stack>
  )
}
